import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import api from '../../api';
import { useAuth } from '../../AuthContext';
import InventoryGrid from '../../components/InventoryGrid';
import IssyBanner from '../../components/IssyBanner';

function BartenderDashboard() {
  const { user } = useAuth();
  const [lowStock, setLowStock] = useState([]);

  useEffect(() => {
    api.get('/inventory?below_par=true&is_food=false')
      .then(({ data }) => setLowStock(data))
      .catch(() => {});
  }, []);

  return (
    <>
      <div className="page-header">
        <span className="page-title">Bar Dashboard</span>
        <span className="text-sm text-gray">{user?.name}</span>
      </div>
      <div className="page-body">
        {lowStock.length > 0 && (
          <div className="alert alert-warning mb-4">
            🍺 {lowStock.length} bar items below par — notify your GM.
          </div>
        )}

        <div className="stat-grid">
          <div className={`stat-card ${lowStock.length > 0 ? 'danger' : 'success'}`}>
            <div className="stat-label">Bar Stock Alerts</div>
            <div className="stat-value">{lowStock.length}</div>
            <div className="stat-sub">below par level</div>
          </div>
        </div>

        <div className="card mt-4">
          <div className="card-header">Low Stock Items</div>
          <div className="card-body">
            {lowStock.length === 0 ? (
              <p className="text-gray text-sm">All bar items stocked. 🍹</p>
            ) : (
              <div className="table-wrap">
                <table>
                  <thead><tr><th>Item</th><th>On Hand</th><th>Par</th><th>Needed</th></tr></thead>
                  <tbody>
                    {lowStock.map(item => (
                      <tr key={item.id}>
                        <td><strong>{item.name}</strong></td>
                        <td>{item.quantity_on_hand} {item.unit}</td>
                        <td>{item.par_level} {item.unit}</td>
                        <td className="text-red font-bold">{Math.max(0, item.par_level - item.quantity_on_hand)} {item.unit}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default function BartenderView() {
  return (
    <Routes>
      <Route index element={<BartenderDashboard />} />
      <Route path="inventory" element={<><div className="page-header"><span className="page-title">Bar Stock</span></div><div className="page-body"><IssyBanner /><InventoryGrid filterFood={false} /></div></>} />
    </Routes>
  );
}
